export default {
    dateFormat: 'do MMMM yyyy',
    autoComplete: 'off',
    placeholderText: 'Please select a date',
    inline: true,
    calendarStartDay: 1,
    useWeekdaysShort: true,
    showPopperArrow: false,
    isClearable: true,
    focusSelectedMonth: false,
    shouldCloseOnSelect: false,
};
